// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"92b22b15","453":"396d632a","455":"9d14e495"}[chunkId] + ".chunk.js";
};